var _g, _g2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_503_6747)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D49EFF",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "url(#paint0_linear_503_6747)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_503_6747)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8833 11.75C15.8833 11.3358 16.2191 11 16.6333 11H23.4289C23.8431 11 24.1789 11.3358 24.1789 11.75V11.9707H25.3118C26.8306 11.9707 28.0618 13.2019 28.0618 14.7207V26.2533C28.0618 27.7721 26.8306 29.0033 25.3118 29.0033H14.75C13.2312 29.0033 12 27.7721 12 26.2533V14.7207C12 13.2019 13.2312 11.9707 14.75 11.9707H15.8833V11.75ZM24.1789 15.6331V13.4707H25.3118C26.0022 13.4707 26.5618 14.0304 26.5618 14.7207V26.2533C26.5618 26.9437 26.0022 27.5033 25.3118 27.5033H14.75C14.0596 27.5033 13.5 26.9437 13.5 26.2533V14.7207C13.5 14.0304 14.0596 13.4707 14.75 13.4707H15.8833V15.6331C15.8833 16.0474 16.2191 16.3831 16.6333 16.3831H18.3322C18.7464 16.3831 19.0822 16.0474 19.0822 15.6331C19.0822 15.4259 19.3581 15.0025 20.0311 15.0025C20.7041 15.0025 20.98 15.4259 20.98 15.6331C20.98 16.0474 21.3158 16.3831 21.73 16.3831H23.4289C23.8431 16.3831 24.1789 16.0474 24.1789 15.6331ZM17.3833 12.5V14.8831H17.7324C18.0999 14.0169 19.0835 13.5025 20.0311 13.5025C20.9787 13.5025 21.9623 14.0169 22.3298 14.8831H22.6789V12.5H17.3833ZM23.6523 20.0465C23.9452 19.7536 23.9452 19.2788 23.6523 18.9859C23.3594 18.693 22.8845 18.693 22.5916 18.9859L19.3282 22.2493L18.1341 21.0552C17.8413 20.7623 17.3664 20.7623 17.0735 21.0552C16.7806 21.3481 16.7806 21.8229 17.0735 22.1158L18.7979 23.8403C18.9386 23.9809 19.1293 24.0599 19.3282 24.0599C19.5271 24.0599 19.7179 23.9809 19.8586 23.8403L23.6523 20.0465Z",
    fill: "#C74AE3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8833 11.75C15.8833 11.3358 16.2191 11 16.6333 11H23.4289C23.8431 11 24.1789 11.3358 24.1789 11.75V11.9707H25.3118C26.8306 11.9707 28.0618 13.2019 28.0618 14.7207V26.2533C28.0618 27.7721 26.8306 29.0033 25.3118 29.0033H14.75C13.2312 29.0033 12 27.7721 12 26.2533V14.7207C12 13.2019 13.2312 11.9707 14.75 11.9707H15.8833V11.75ZM24.1789 15.6331V13.4707H25.3118C26.0022 13.4707 26.5618 14.0304 26.5618 14.7207V26.2533C26.5618 26.9437 26.0022 27.5033 25.3118 27.5033H14.75C14.0596 27.5033 13.5 26.9437 13.5 26.2533V14.7207C13.5 14.0304 14.0596 13.4707 14.75 13.4707H15.8833V15.6331C15.8833 16.0474 16.2191 16.3831 16.6333 16.3831H18.3322C18.7464 16.3831 19.0822 16.0474 19.0822 15.6331C19.0822 15.4259 19.3581 15.0025 20.0311 15.0025C20.7041 15.0025 20.98 15.4259 20.98 15.6331C20.98 16.0474 21.3158 16.3831 21.73 16.3831H23.4289C23.8431 16.3831 24.1789 16.0474 24.1789 15.6331ZM17.3833 12.5V14.8831H17.7324C18.0999 14.0169 19.0835 13.5025 20.0311 13.5025C20.9787 13.5025 21.9623 14.0169 22.3298 14.8831H22.6789V12.5H17.3833ZM23.6523 20.0465C23.9452 19.7536 23.9452 19.2788 23.6523 18.9859C23.3594 18.693 22.8845 18.693 22.5916 18.9859L19.3282 22.2493L18.1341 21.0552C17.8413 20.7623 17.3664 20.7623 17.0735 21.0552C16.7806 21.3481 16.7806 21.8229 17.0735 22.1158L18.7979 23.8403C18.9386 23.9809 19.1293 24.0599 19.3282 24.0599C19.5271 24.0599 19.7179 23.9809 19.8586 23.8403L23.6523 20.0465Z",
    fill: "#F7E4FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_503_6747",
    x: -15,
    y: -15,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_503_6747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_503_6747",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.619608 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_503_6747"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_503_6747",
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_503_6747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_503_6747",
    x1: 8.5,
    y1: 3.5,
    x2: 24.4026,
    y2: 34.5734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D49EFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49EFF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactions);
export default __webpack_public_path__ + "static/media/icon-transactions.e7153bddb801ccfcb8cf0541940ac2d8.svg";
export { ForwardRef as ReactComponent };